import type { AxiosRequestConfig } from 'axios';
import { z } from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

export const DownloadFamilyCommunicationResponseDtoSchema = z.object({
  url: z.string(),
});

export type DownloadFamilyCommunicationResponseDto = z.infer<
  typeof DownloadFamilyCommunicationResponseDtoSchema
>;

export type DownloadFamilyCommunicationRequestDto = {
  id: number;
};

export const downloadFamilyCommunication = (
  params: DownloadFamilyCommunicationRequestDto,
  config?: AxiosRequestConfig
) => {
  return api
    .get(`family-communication/${params.id}/download`, config)
    .then(responseContract(DownloadFamilyCommunicationResponseDtoSchema));
};
